import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';



const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8',
 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Credentials': 'true',
  'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS'});


@Injectable()
export class SalesService {
salesModelUrl = '/superadmin/rest/mgmt/sc/commission';
salesModelCountUrl = '/superadmin/rest/mgmt/sc/commission/count?';
salesConfigUrl = '/superadmin/rest/mgmt/sc/config';
salesChannelCountUrl = '/superadmin/rest/mgmt/sc/count?';
salesChannelpartnerCountUrl = '/superadmin/rest/mgmt/account/sc/count?';
salesChannelUrl = '/superadmin/rest/mgmt/sc';
salespartnerChannelUrl = '/superadmin/rest/mgmt/account/sc';
salesRepCountUrl = '/superadmin/rest/mgmt/sc/rep/count?';
salesRepUrl = '/superadmin/rest/mgmt/sc/rep';
CommissionReportUrl = '/superadmin/rest/mgmt/sc/commission';
CommissionReportlistUrl = '/superadmin/rest/mgmt/sc/commission';
ScInvoicelistUrl = '/superadmin/rest/mgmt/sc/invoice';
ScInvoiceCountUrl = '/superadmin/rest/mgmt/sc/invoice/count?';
invoiceUrl = '/superadmin/rest/mgmt/account/license/invoice/markAsNotPaid';
    constructor(private http: HttpClient) { }

    getSalesModels(filter, sortOrder, pageNumber, pageSize = 10): Observable<any> {
        return this.http.get(this.salesModelUrl + '?' + filter, {
          params: new HttpParams()
            .set('asc', sortOrder)
            .set('from', pageNumber.toString())
            .set('count', pageSize.toString())
        });

      }
      getSalesModelById(id) {
        return this.http.get(this.salesModelUrl + '/' + id,  {headers: headers} );
      }
      getSalesChannels(filter, sortOrder, pageNumber, pageSize = 10): Observable<any> {
        return this.http.get(this.salesChannelUrl + '?' + filter, {
          params: new HttpParams()
            .set('asc', sortOrder)
            .set('from', pageNumber.toString())
            .set('count', pageSize.toString())
        });

      }
      getSalespartnerChannels(filter, sortOrder, pageNumber, pageSize = 10): Observable<any> {
        return this.http.get(this.salespartnerChannelUrl + '?' + filter, {
          params: new HttpParams()
            .set('asc', sortOrder)
            .set('from', pageNumber.toString())
            .set('count', pageSize.toString())
        });

      }

      getTotalSalesModelCount(filters) {
        return this.http.get(this.salesModelCountUrl + filters, { headers: headers });
      }
      createSalesModel(formData) {
        return this.http.post(this.salesModelUrl, formData, { headers: headers});
      }
      updateSalesModel(formData, salesModelId) {
        return this.http.put(this.salesModelUrl + '/' + salesModelId, formData, {headers: headers});
      }
      // updateSalesModel(formData) {
      //   return this.http.put(this.salesModelUrl + '/' +  formData, {headers: headers});
      // }
      deleteSalesModel(id) {
        return this.http.delete(this.salesModelUrl + '/' + id,  {headers: headers});
      }
      getSalesConfig() {
        return this.http.get(this.salesConfigUrl, { headers: headers});
      }
      getTotalSalesChannelCount(filters) {
        return this.http.get(this.salesChannelCountUrl + filters, { headers: headers });
      }
      getTotalSalespartnerChannelCount(filters) {
        return this.http.get(this.salesChannelpartnerCountUrl + filters, { headers: headers });
      }
      createSalesChannel(formData) {
        return this.http.post(this.salesChannelUrl , formData, { headers: headers });
      }
      getSalesChannelById(id) {
        return this.http.get(this.salesChannelUrl + '/' + id,  {headers: headers} );
      }

      changeSalesChannelStatus(id, status) {
        return this.http.put(this.salesChannelUrl + '/' +  id + '/' + status, {headers: headers});
      }
      updateSalesChannel(data) {
        return this.http.put(this.salesChannelUrl + '/' + data.scId , data, {headers: headers});
      }
      deleteSalesChannel(id) {
        return this.http.delete(this.salesChannelUrl + '/' + id,  {headers: headers});
      }
      getTotalSalesRepCount(filters) {
        return this.http.get(this.salesRepCountUrl + filters, { headers: headers });
      }
      getSalesReps(filter, sortOrder, pageNumber, pageSize = 10): Observable<any> {
        return this.http.get(this.salesRepUrl + '?' + filter, {
          params: new HttpParams()
            .set('asc', sortOrder)
            .set('from', pageNumber.toString())
            .set('count', pageSize.toString())
        });

      }

      updateSalesRep(data, repid) {
        return this.http.put(this.salesRepUrl + '/' +  repid , data, {headers: headers});
      }
      saveSalesRep(data) {
        return this.http.post(this.salesRepUrl , data, {headers: headers});
      }
      getSalesRepById(id) {
        return this.http.get(this.salesRepUrl + '/' + id,  {headers: headers} );
      }
      changeSalesRepStatus(id, status) {
        return this.http.put(this.salesRepUrl + '/' +  id + '/' + status, {headers: headers});
      }
      deleteSalesRep(id) {
        return this.http.delete(this.salesRepUrl + '/' + id,  {headers: headers});
      }
      createCommissionReport() {
        return this.http.post(this.CommissionReportUrl , { headers: headers });
      }
      getCommission( filter, sortOrder,
        pageNumber, pageSize = 10): Observable<any> {
          return this.http.get(this.CommissionReportlistUrl + '?' +  filter, {
              params: new HttpParams()
              .set('asc', sortOrder)
                  .set('from', pageNumber.toString())
                  .set('count', pageSize.toString())
          });
        }
        getTotalFilterCount(filter: any): any {
          return this.http.get(this.CommissionReportlistUrl + '/count?' + filter, { headers: headers });
        }
        getTotalCommissionCount(filters) {
          return this.http.get(this.salesModelCountUrl + filters, { headers: headers });
        }
        getCommissionById(commReportId) {
          return this.http.get(this.CommissionReportlistUrl + '/' + commReportId,  {headers: headers} );
        }
        updateCommissionChannel(data) {
          return this.http.put(this.CommissionReportlistUrl + '/' + data.comReportId , data, {headers: headers});
        }
        changeCommissionReportStatus(id, status) {
          return this.http.put(this.CommissionReportUrl + '/' +  id + '/' + status, {headers: headers});
        }
        getScInvoice( filter, sortOrder,
          pageNumber, pageSize = 10): Observable<any> {
            return this.http.get(this.ScInvoicelistUrl + '?' +  filter, {
                params: new HttpParams()
                .set('asc', sortOrder)
                    .set('from', pageNumber.toString())
                    .set('count', pageSize.toString())
            });
          }
          getTotalScInvoiceCount(filters) {
            return this.http.get(this.ScInvoicelistUrl + '/count?' + filters, { headers: headers });
          }
          getscInvoiceById(id) {
            return this.http.get(this.ScInvoicelistUrl + '/' + id,  {headers: headers} );
          }
          markasnotPaid(id) {
            return this.http.put(this.invoiceUrl + '/' +  id , {headers: headers});
          }
}
